import { Component } from '@angular/core';

@Component({
  selector: 'axis-timepicker-template',
  template: '<div class="overlay"></div>',
  host: { class: 'axis-timepicker-overlay' }
})
export class TimepickerTemplateComponent {
  // @HostBinding('class.axis-timepicker-overlay') axisTimepickerOverlay = true;
}
